import * as PropTypes from 'prop-types'
import { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { ZoomFrame } from '@/components/ui/zoomable-image'
import { getAssetLink } from '../../../helpers/get-asset-link'
import {
  fetchNeighbourhoodPerks,
  selectNeighbourhoodPerksById,
} from '../../../reducers/Organisation/neighbourhoodPerksReducer'
import { fetchSingleBuilding } from '../../../reducers/buildingSelectorReducer'
import { selectUserData } from '../../../reducers/userDataReducer'
import categories from '../../CreatePerks/categories'
import Dashboard from '../../Dashboard'
import Icon from '../../Icons'

const NeighborhoodPerks = ({
  fetchSingleBuilding,
  fetchNeighbourhoodPerks,
  neighborhoodPerksData,
  userData,
}) => {
  const { t } = useTranslation(['neighborhood-perks'])
  const [selectedPerk, setSelectedPerk] = useState('')

  useEffect(() => {
    fetchSingleBuilding(userData.buildingId.id)
  }, [userData])

  useEffect(() => {
    fetchNeighbourhoodPerks(userData.buildingId.id)
  }, [])

  return (
    <Dashboard.Container className={`ctp-neighborhood-perks`}>
      <div className="neighborhood-perks-section">
        <div className={`neighborhood-perks-section__inner`}>
          {neighborhoodPerksData.length > 0 &&
            categories.map((category) => {
              const perksOfThisCategory = neighborhoodPerksData.filter(
                (neighbourhoodPerk) => neighbourhoodPerk.category === category.text,
              )

              if (perksOfThisCategory.length > 0) {
                return (
                  <Fragment key={category.id}>
                    <div className="category-header">
                      <h3>{t(`neighborhood-perks:categories.${category.key}`)}</h3>
                      <div />
                    </div>
                    <div className="category-container">
                      {perksOfThisCategory.map((perk) => (
                        <div
                          key={perk.id}
                          className={`item-container ${selectedPerk.id === perk.id && 'selected'}`}
                          onClick={() => setSelectedPerk(perk)}
                        >
                          <div className="image-container">
                            <img
                              src={getAssetLink({
                                path: 'chitown-images/neighbourhood',
                                file: perk.image,
                                fallback: { file: 'neighbourhood_image.png' },
                              })}
                            />
                          </div>
                          <div className="discount-container">
                            <div className="discount-logo">
                              <img
                                src={getAssetLink({
                                  path: 'chitown-images/neighbourhood',
                                  file: perk.logo,
                                  fallback: { file: 'neighbourhood_image.png' },
                                })}
                              />
                            </div>
                            <span>{perk.tag}</span>
                          </div>
                          <div className="perk-info">
                            <div className="perk-info-name">
                              {perk.name.length > 20 ? `${perk.name.slice(0, 20)}..` : perk.name}
                            </div>
                            <div className="perk-info-desc">
                              {perk.description.length > 60
                                ? `${perk.description.slice(0, 60)}..`
                                : perk.description}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Fragment>
                )
              }
            })}
        </div>
      </div>
      {selectedPerk && (
        <div className="neighborhood-perks-sidebar">
          <h3>{t('neighborhood-perks:sidebar.title')}</h3>
          <div className="image-container">
            <ZoomFrame
              fill
              src={getAssetLink({
                path: 'chitown-images/neighbourhood',
                file: selectedPerk.image,
                fallback: { file: 'neighbourhood_image.png' },
              })}
              style={{ borderRadius: '2.5px' }}
              title={selectedPerk.name}
            >
              <img
                src={getAssetLink({
                  path: 'chitown-images/neighbourhood',
                  file: selectedPerk.image,
                  fallback: { file: 'neighbourhood_image.png' },
                })}
              />
            </ZoomFrame>
          </div>
          <div className="icon-and-title-container">
            <div className="icon">
              <img
                src={getAssetLink({
                  path: 'chitown-images/neighbourhood',
                  file: selectedPerk.logo,
                  fallback: { file: 'neighbourhood_image.png' },
                })}
              />
            </div>
            <div className="title">
              <span>{selectedPerk.name}</span>
            </div>
          </div>
          <div className="info-container">
            <div className="discount-container">
              <Icon icon="gift" viewBox="0 0 25 25" />
              <span className="bolded-text">{selectedPerk.tag}</span>
            </div>
            <div className="description-container">
              <Icon icon="info" viewBox="0 0 25 25" />
              <div className="description-wrap">
                <div className="bolded-text">
                  {t('neighborhood-perks:sidebar.descriptionLabel')}
                </div>
                <span className="description">{selectedPerk.description}</span>
              </div>
            </div>
            {selectedPerk.link ? (
              <div className="promo-discount-container">
                <Icon icon="discount" viewBox="0 0 25 25" />
                <div className="promo-container">{selectedPerk.link}</div>
              </div>
            ) : null}
            {selectedPerk.url ? (
              <div className="promo-discount-container">
                <Icon icon="discount" viewBox="0 0 25 25" />
                <a target="_blank" href={selectedPerk.url} className="promo-container">
                  {selectedPerk.url}
                </a>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </Dashboard.Container>
  )
}

NeighborhoodPerks.propTypes = {
  fetchNeighbourhoodPerks: PropTypes.func,
  neighborhoodPerksData: PropTypes.array,
  fetchSingleBuilding: PropTypes.func,
  userData: PropTypes.object,
}

export default connect(
  (state) => {
    const userData = selectUserData(state)
    return {
      neighborhoodPerksData: selectNeighbourhoodPerksById(state, userData.buildingId.id),
      userData,
    }
  },
  {
    fetchNeighbourhoodPerks,
    fetchSingleBuilding,
  },
)(NeighborhoodPerks)
